function MapCard() {
    "use strict";
    this.Id = 'z-1';
    this.Name = '';
    this.EnrolleeName = '';
    this.EnrolleeFirstName = '';
    this.EnrolleeLastName = '';
    this.EnrolleeId = -1;
    this.DisplayName = '';
    this.Date = new Date(0);
    this.Detail = '- unknown -';
    this.Detail2 = '';
    this.Detail3 = '';
    this.Detail4 = '';
    this.VisitId = -1;
    this.Latitude = '';
    this.Longitude = '';
    this.ExtendedDetail = '';
    this.SecondExtendedDetail = '';
    this.IsExpanded = false;
    //this.DataItem = null;
    this.IconClass = '';
    this.TrackItem = null;
    this.InventoryBatteryClass = '';
    this.InventorySignalClass = '';
    this.SortDate = new Date(250000000000000);
    this.SortOrder = -1;
    this.TagId = -1;
    this.TagName = '';
    this.GsmSignalStrength = 0;
    this.IsGeocoded = false;
    this.Address = '- retrieving address -';
    this.isMapped = true;
    this.EditDisplay = 'style="width:0;height:0"';
    this.ZoneRadius = 0;
    this.HasMapEvents = false;
    this.HasConfirmedEvents = false;
    this.Type = -1;
    this.Association = null;
    this.EnrolleePosition = 1;
    /*
        Address = 1 (aId)
        Zone = 2 (zId)
        Visit = 3 (vVisitGroupingId)
        Visit Point = 4 (tTrackpointId)
        Trip Point = 5 (tTrackpointId)
    */

    this.CorrelateDisplay = 'none';
    this.IsAssociationVisit = false;
    this.CorrelationAtKnownLocation = 'none';
    this.GenericMapEvents = 'none';
    this.iconId;
    this.SVGMarker = '';
    this.SVGDisplay = 'none';
    this.iconUri = '';
    this.MarkerSingleIcon = 'block';
}
if (typeof exports !== 'undefined') {
    module.exports = MapCard;
}